import React from "react"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
class StructureHullSystem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addStructureHull:
            {
                createdBy: "",
                createdDate: "",
                location: "",
                modifiedBy: "",
                modifiedDate: "",
                name: "",
                material:"",
                structureAndHullId: null,
                parts: "",
                pchmchm: "",
                purchaseOrderId: null,
                quantity: "",
                remarks: "",
                shipId: null,
                unit: "",
                isUpdated: false,
                isDeleted: false

            },
            StructureAndHull: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    componentDidMount() {
        const { match, option } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        if (option == "Add") {
            this.state.addStructureHull.shipId = parseInt(shipid);
            this.state.addStructureHull.purchaseOrderId = parseInt(poid);
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            StructureAndHull: props.structureAndHull,
            addStructureHull: props.updateDetails,
        };
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.addStructureHull[nodeName] = e.target.value;
        this.state.addStructureHull.isUpdated = true;
        this.setState({});
    }

    addStructureHullDetails() {
        this.state.addStructureHull.isDeleted = false;
        this.state.StructureAndHull.unshift({...this.state.addStructureHull});
        this.props.dispatch({ type: "GetStructureAndHullSuccess", data: this.state.StructureAndHull });
        // this.setState({addStructureHull:
        //     {
        //         createdBy: "",
        //         createdDate: "",
        //         location: "",
        //         modifiedBy: "",
        //         modifiedDate: "",
        //         name: "",
        //         material:"",
        //         structureAndHullId: null,
        //         parts: "",
        //         pchmchm: "",
        //         purchaseOrderId: null,
        //         quantity: "",
        //         remarks: "",
        //         shipId: null,
        //         unit: "",
        //         isUpdated: false,
        //         isDeleted: false

        //     }});
        // this.hideSidePanel();
    }

    cancel() {
        this.hideSidePanel();
    }

    UpdateStructureHull() {
        const { addStructureHull } = this.state;
        var index = this.state.StructureAndHull.findIndex(x => x.structureAndHullId === addStructureHull.structureAndHullId);
        if (index === -1) {
            // handle error
        }
        else {
            this.setState({
                StructureAndHull: [
                    ...this.state.StructureAndHull.slice(0, index),
                    Object.assign({}, this.state.StructureAndHull[index], addStructureHull),
                    ...this.state.StructureAndHull.slice(index + 1)
                ]
            }, () => {
                this.props.dispatch({ type: "GetStructureAndHullSuccess", data: this.state.StructureAndHull });
                this.hideSidePanel();
            });
        }
    }


    render() {
        const { option } = this.props;

        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                        </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {option == "Add" ? "Add " : "Update "} Structure & Hull
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Name </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.name} name="name" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Location </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.location} name="location" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Materials </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.material} name="material" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Parts </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.parts} name="parts" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">Remarks </label><br></br>
                                                <textarea className="form-control" value={this.state.addStructureHull.remarks} name="remarks" onChange={e => this.handleInputChange(e)} ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            Approximate Quantity
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Quantity </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.quantity} name="quantity" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Unit </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.unit} name="unit" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">PCHM / CHM </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStructureHull.pchmchm} name="pchmchm" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 search-filter-box mt-2">
                                        <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                            {this.props.option === "Add" ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.addStructureHullDetails()}
                                                >
                                                    {" "}Add{" "}
                                                </button>
                                                : null}
                                            {this.props.option === "Edit" ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.UpdateStructureHull()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                                : null}
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button" onClick={() => this.cancel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ShowSidePan: state.SidePanReducer.sidePan || false,
        structureAndHull: state.MMPLDashboardReducer.StructureAndHull || [],

    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StructureHullSystem));